import { useState } from "react";
import emailjs from "emailjs-com";

const SENDGRID_LAMBDA_URL = 'https://a9xpq6loab.execute-api.eu-central-1.amazonaws.com/default/sendEmailSendgrid';

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const [show, setShow] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await sendEmailSendgrid();

    emailjs
      .sendForm(
        "service_adb2ade",
        "template_9fpiaxv",
        e.target,
        "Oxmz9-JyA4UUg0NVs"
      )
      .then(
        function (result) {
          if (result.status === 200) setShow(false);
          else alert("Sorry there was a problem. Please try again...!!!");
        },
        function (error) {
          console.log(error.text);
          alert("Sorry there was a problem. Please try again...!!!");
        }
      );
  };

  const sendEmailSendgrid = async () => {
      const htmlTemplate = `
        <h3>Name: ${name}</h3>
        <h3>Email: ${email}</h3>
        <p>Message: ${message}</p>
    `;

      const emailData = {
          to: "contact@softwarenetic.com",
          subject: "Softwarenetic: Email by " + name,
          text: 'Email from ' + name + ' (' + email + '): ' + message,
          html: htmlTemplate
      };

      try {
          const response = await fetch(SENDGRID_LAMBDA_URL, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(emailData)
          });

          const data = await response.json();
          console.log('Response from Lambda:', data);
      } catch (error) {
          console.error('Error sending email:', error);
      }
  }

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                {show ? (
                  <p>
                    Please fill out the form below to send us an email and we
                    will get back to you as soon as possible.
                  </p>
                ) : (
                  <p>
                    Contact form successfully submitted. Thank you, we will get
                    back to you soon!
                  </p>
                )}
              </div>
              <form name="sentMessage" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      {show ? (
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          placeholder="Name"
                          required
                          onChange={handleChange}
                        />
                      ) : null}
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      {show ? (
                        <input
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          required
                          onChange={handleChange}
                        />
                      ) : null}
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  {show ? (
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="Message"
                      required
                      onChange={handleChange}
                    ></textarea>
                  ) : null}
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                {show ? (
                  <button type="submit" className="btn btn-custom btn-lg">
                    Send Message
                  </button>
                ) : null}
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                  {props.data ? props.data.address : "loading"}
              </p>
            </div>

            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>
                <a
                  href={
                    "mailto:contact@softwarenetic.com"
                  }
                >
                  {props.data ? props.data.email : "loading"}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-left footer-text-box">
          <div className="footer-links">
            <div className="sections">
              <div>
                <a href="#header" className="footer-text page-scroll">
                  Services
                </a>
              </div>
              <div>
                <a href="#solutions" className="footer-text page-scroll">
                  Solutions
                </a>
              </div>
              <div>
                <a href="#portfolio" className="footer-text page-scroll">
                  Portfolio
                </a>
              </div>
              <div>
                <a href="#technologies" className="footer-text page-scroll">
                  Technologies
                </a>
              </div>
              <div>
                <a href="#about" className="footer-text page-scroll">
                  About us
                </a>
              </div>
              <div>
                <a href="#Team" className="footer-text page-scroll">
                  Team
                </a>
              </div>
            </div>

            <div className="social">
              <a
                href={props.data ? props.data.linkedin : "/"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-linkedin"></i>
              </a>
              <a
                href={props.data ? props.data.facebook : "/"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-facebook"></i>
              </a>
              <a
                href={props.data ? props.data.twitter : "/"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-twitter"></i>
              </a>
              <a
                href={props.data ? props.data.instagram : "/"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="container text-center">
          <p>
            &copy; {new Date().getFullYear()} Softwarenetic. All rights reserved
          </p>
        </div>
      </div>
    </div>
  );
};
